export var props = {
  header: {
    type: [Object, Array],
    required: false,
    default: () => ({
      name: '礼物名称',
      num: '数量',
      createdAt: '获得时间'
    })
  },
  getServerData: {
    type: Function,
    required: false
  },
  dateFormat: {
    type: String,
    required: false,
    default: 'YYYY-MM-DD hh:mm'
  },
  formatter: {
    type: Function,
    required: false
  },
  params: {
    type: Object,
    required: false,
    default: () => ({})
  },
  fetchErrorMsg: {
    type: String,
    required: false,
    default: '获取抽奖记录失败，请稍后再试试吧~'
  },
  showLoading: {
    type: Boolean,
    required: false,
    default: true
  },
  emptyText: {
    type: String,
    required: false,
    default: '暂无数据'
  },
  tipsText: {
    type: String,
    required: false,
    default: '仅仅展示100条记录'
  },
  noTips: {
    type: Boolean,
    required: false,
    default: false
  },
  immediate: {
    type: Boolean,
    required: false,
    default: true
  },
  actId: {
    type: String,
    required: false,
    default: ''
  },
  resultPath: {
    type: String,
    default: 'data.list'
  }
};